import React, { useState, useContext } from "react";
import { motion } from "framer-motion";
import { toTitleCase } from "../commonfunctions/TitleCase";

interface ImageProps {
  src: string;
  className?: string;
  loading?: "lazy" | "eager";
  onClick?: () => void;
  testId?: string;
  objectFit?: string;
  disabled?: boolean;
  tableActions?: boolean;
  index?: number;
  tooltiptype?: string;
  // Add this new prop
  tooltipPosition?: { 
    isFirst: boolean; 
    isLast: boolean;
    total: number;
    position: number;
    totalActions: number;
  };
  tooltipContent?: string;
  tableColumns?: number;
}

const Image: React.FC<ImageProps> = ({
  src,
  className = "",
  loading = "lazy",
  onClick,
  testId,
  objectFit,
  disabled=false,
  tableActions,
  index = 0,
  tooltiptype,
  tooltipPosition,
  tableColumns,
  tooltipContent
}) => {
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
  };

  const [tooltip, setToolTip] = useState(false);
  // Calculate tooltip position based on which button this is
  const calculateTooltipPosition = () => {
    if (!tooltipPosition) return 'calc(100% - 16px)';
    
    // If it's the only action button
    if (tooltipPosition.total === 2 && tooltipPosition.isLast) {
      return 'calc(100% - 50px)';
    }
    
    // If it's the first button (rightmost)
    if (tooltipPosition.isFirst) {
      if(tableColumns && tableColumns < 5) {
        return 'calc(100% - 25px)';
      }
      if (tooltipPosition.totalActions === 1) {
        return 'calc(100% - 25px)';
      }
      return 'calc(100% - 16px)';
    }
    
    // Calculate based on position
    const baseOffset = 16;
    const buttonWidth = 24; // Approximate width of button
    const gap = 14; // Gap between buttons from your CSS "gap-[14px]"
    
    const offset = baseOffset + (tooltipPosition.total - tooltipPosition.position) * (buttonWidth + gap);
    return `calc(100% - ${offset}px)`;
  };

  return (
    <>
      <motion.img
        src={`/images/${src}.svg`}
        alt={src}
        className={`${objectFit ? objectFit : 'object-cover'} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
        loading={loading}
        onClick={disabled ? undefined : onClick}
        variants={tableActions ? {} : imageVariants}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.6, ease: "easeOut" }}
        data-testid={testId ? testId : src}
        onMouseEnter={disabled ? undefined : () => setToolTip(true)}
        onMouseLeave={disabled ? undefined : () => setToolTip(false)}
      />
      {tooltiptype && tooltip && (
        <div
          className="absolute z-50 bg-black text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap"
          style={{
            top: '50%',
            right: calculateTooltipPosition(),
            transform: 'translateY(-48%)',
          }}
        >
          {tooltipContent ? tooltipContent : toTitleCase(tooltiptype)}
        </div>
      )}
    </>
  );
};

export default Image;